import { CartLinesUpdateEvent } from '@shopify/events';

const ADD_URL = window.Theme?.routes?.cart_add_url || '/cart/add.js';
const CART_URL = (window.Theme?.routes?.cart_url || '/cart') + '.js';

async function addToCart(form) {
  const formData = new FormData(form);
  const quantity = Number(formData.get('quantity')) || 1;

  const deferred = CartLinesUpdateEvent.createPromise();
  document.dispatchEvent(
    new CartLinesUpdateEvent({
      action: 'add',
      context: 'product',
      lines: [{ merchandiseId: String(formData.get('id')), quantity }],
      promise: deferred.promise,
    })
  );

  try {
    const res = await fetch(ADD_URL, {
      method: 'POST',
      headers: { Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: formData,
    });
    const added = await res.json();
    if (added.status) throw new Error(added.description || added.message || 'Add to cart failed');

    const cart = await fetch(CART_URL, { headers: { Accept: 'application/json' } }).then((r) => r.json());
    deferred.resolve({
      cart: CartLinesUpdateEvent.createCartFromAjaxResponse(cart),
      detail: {
        source: 'custom-add-to-cart',
        items: cart.items,
        itemCount: cart.item_count,
        didError: false,
      },
    });

    const drawer = document.querySelector('cart-items-component');
    if (drawer) {
      await customElements.whenDefined('cart-items-component');
      drawer.fetchCartData?.();
    }
  } catch (err) {
    deferred.reject(err);
    console.error('[cart-sync]', err);
  }
}

document.addEventListener('submit', (event) => {
  const form = event.target;
  if (!(form instanceof HTMLFormElement)) return;
  if (!/\/cart\/add/.test(form.getAttribute('action') || '')) return;
  if (form.closest('product-form-component')) return;
  event.preventDefault();
  addToCart(form);
});